import React from 'react';
import { Paper, Typography, useTheme } from '@mui/material';
import { BarElement, CategoryScale, Chart as ChartJS, LinearScale, Tooltip } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

// Counts are people: whole numbers only, starting at zero.
const COUNT_AXIS = { beginAtZero: true, ticks: { precision: 0 } };

const ChartCard: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <Paper component="section" aria-label={title} sx={{ p: 2, height: '100%' }}>
    <Typography variant="overline" color="text.secondary" sx={{ display: 'block' }}>
      {title}
    </Typography>
    <div style={{ position: 'relative', height: 220 }}>{children}</div>
  </Paper>
);

export const DailyActiveChart: React.FC<{ days: Array<{ date: string; count: number }> }> = ({ days }) => {
  const theme = useTheme();
  return (
    <ChartCard title="Daily active users">
      <Bar
        data={{
          // MM/DD is enough: the window is at most 30 days.
          labels: days.map((day) => day.date.slice(0, 5)),
          datasets: [
            { label: 'Active users', data: days.map((day) => day.count), backgroundColor: theme.palette.primary.main },
          ],
        }}
        options={{ maintainAspectRatio: false, scales: { y: COUNT_AXIS } }}
      />
    </ChartCard>
  );
};

export const ModuleUsageChart: React.FC<{ modules: Array<{ module: string; users: number }> }> = ({ modules }) => {
  const theme = useTheme();
  return (
    <ChartCard title="Users by module">
      <Bar
        data={{
          labels: modules.map((row) => row.module),
          datasets: [
            { label: 'Users', data: modules.map((row) => row.users), backgroundColor: theme.palette.primary.main },
          ],
        }}
        options={{ indexAxis: 'y', maintainAspectRatio: false, scales: { x: COUNT_AXIS } }}
      />
    </ChartCard>
  );
};
